import Highcharts from 'highcharts';
import HighchartsMap from 'highcharts/modules/map';
import BaseChart from '../baseChart';

HighchartsMap(Highcharts);

export default function BaseChartMap(props) {
  return <BaseChart {...props} />;
}
